import React, { useCallback, useState } from 'react';
import styles from './index.module.scss';
import HeadContainer from '../../head-container';
import classNames from 'classnames';
import { getImageFromS3 } from '../../../imageService';

const challengeList = {
  questions: [
    {
      id: 1,
      title: 'Яку базу для коктейлю обереш?',
      image: getImageFromS3('/images/find-your-cocktail-challenge/1.png'),
      answerList: [
        { id: 1.1, title: 'А) Газована вода' },
        { id: 1.2, title: 'Б) Сік' },
        { id: 1.3, title: 'В) Чай' },
        { id: 1.4, title: 'Г) Молоко' }
      ]
    },
    {
      id: 2,
      title: 'Що додаси до основи?',
      image: getImageFromS3('/images/find-your-cocktail-challenge/2.png'),
      answerList: [
        { id: 2.1, title: 'А) Фрукти' },
        { id: 2.2, title: 'Б) Лід' },
        { id: 2.3, title: 'В) Листя трав, квіти' },
        { id: 2.4, title: 'Г) Сироп' }
      ]
    },
    {
      id: 3,
      title: 'Який смак має твоя ідеальна комбінація?',
      image: getImageFromS3('/images/find-your-cocktail-challenge/3.png'),
      answerList: [
        { id: 3.1, title: 'А) Солодкий' },
        { id: 3.2, title: 'Б) Кислуватий' },
        { id: 3.3, title: 'В) З гірчинкою' },
        { id: 3.4, title: 'Г) Свіжий, освіжаючий' }
      ]
    },
    {
      id: 4,
      title: 'Чим прикрасиш свій напій?',
      image: getImageFromS3('/images/find-your-cocktail-challenge/4.png'),
      answerList: [
        { id: 4.1, title: 'А) Цукровим обідком' },
        { id: 4.2, title: 'Б) Їстівними блискітками' },
        { id: 4.3, title: 'В) Листям ананаса' },
        { id: 4.4, title: 'Г) Красивою соломинкою' }
      ]
    },
    {
      id: 5,
      title: 'Що йде в комплекті до твого коктейлю мрії?',
      image: getImageFromS3('/images/find-your-cocktail-challenge/5.png'),
      answerList: [
        { id: 5.1, title: 'А) Пляж і шум хвиль' },
        { id: 5.2, title: 'Б) Вечірка з друзями на даху' },
        { id: 5.3, title: 'В) Спокій і тиша' },
        { id: 5.4, title: 'Г) Пікнік у парку' }
      ]
    }
  ],
  resultList: [
    {
      id: 1,
      title: 'Лимонад із ревенем',
      description:
        'Ти вмієш розфарбовувати рутину і надихаєш інших насолоджуватись моментом.',
      image: getImageFromS3('/images/find-your-cocktail-challenge/result1.png'),
      recipeText:
        'Лови рецепт! Він вартий того, щоб шукати в магазині ревінь.\n\n' +
        ' 1. Наріж 2 стебла ревеню, провари з 500 мл води й 2 ст.л. цукру близько 10 хв.\n\n' +
        ' 2. Додай сік половинки лимона, охолоди.\n\n' +
        ' 3. Проціди, додай лід і газовану воду — за бажанням.\n\n' +
        'Готово! Освіжає не гірше, ніж кондиціонер.'
    },
    {
      id: 2,
      title: 'Коктейль зі свіжих фруктів',
      description:
        'З тобою завжди весело. Любиш швидкий ритм життя і вмієш знайти гармонію навіть в хаосі.',
      image: getImageFromS3('/images/find-your-cocktail-challenge/result2.png'),
      recipeText:
        'Фруктовий настрій за 2 хвилини? Легко!\n\n' +
        ' 1. Вичави апельсиновий і яблучний фреш (приблизно по 100 мл).\n\n' +
        ' 2. Додай трохи соку лайма.\n\n' +
        ' 3. Збий усе з льодом у шейкері або просто перемішай у склянці.\n\n' +
        'Вуаля! Твій напій готовий.\n'
    },
    {
      id: 3,
      title: 'Сенча з кавуном',
      description:
        'Ти багатогранна особистість з безліччю родзинок.\n\n' +
        'Твоєї енергії вистачило б на освітлення цілого міста.',
      image: getImageFromS3('/images/find-your-cocktail-challenge/result3.png'),
      recipeText:
        'Рецепт незвичний, але простий і цікавий!\n\n' +
        ' 1. Завари 1 ч.л. сенчі на 200 мл води (70–80°C), настоюй 2 хв.\n\n' +
        ' 2. Збий 100–150 г м’якоті кавуна в блендері.\n\n' +
        ' 3. Змішай чай з кавуном, додай трішки меду, лід і м’яту.\n\n' +
        'Насолоджуйся!'
    },
    {
      id: 4,
      title: 'Ягідний мілкшейк!',
      description:
        'Ледь солодкий, але не приторний.\n\n' +
        'З тобою будь-який літній день перетворюється в яскраву пригоду.',
      image: getImageFromS3('/images/find-your-cocktail-challenge/result4.png'),
      recipeText:
        'Тримай рецепт, що стане чудовим доповненням до твого дня.\n\n' +
        '1. Змішай 200 г будь-яких свіжих або заморожених ягід з 200 мл молока.\n\n' +
        ' 2. Додай 1 ст.л. меду або сиропу за смаком.\n\n' +
        ' 3. Збивай усе в блендері до кремової консистенції.\n\n' +
        'Ось і все! Кілька кроків і літня класика готова.'
    }
  ]
};

const FindYourCocktailChallenge = ({
  backgroundImage,
  setScreenNumber,
  afterResultButtonScreen
}) => {
  const [challengeStep, setChallengeStep] = useState(0);
  const [selectQuestion, setSelectQuestion] = useState(
    challengeList?.questions[0]
  );
  const [correctAnswerValue, setCorrectAnswerValue] = useState(0);
  const [isWelcomeScreen, setIsWelcomeScreen] = useState(true);
  const [isResultScreen, setIsResultScreen] = useState(false);
  const [isAfterResultScreen, setIsAfterResultScreen] = useState(false);
  const [answers, setAnswers] = useState([]);
  const [isOpenRecipeModal, setIsOpenRecipeModal] = useState(false);

  const onAnswerClick = useCallback(
    (value) => {
      setAnswers((prev) => ({ ...prev, [challengeStep]: value }));
    },
    [answers, challengeStep]
  );

  const onFinishClick = () => {
    const answerCounts = {};
    for (const key in answers) {
      const answerNumber = parseInt(
        answers[key].answerId.toString().split('.')[1]
      );
      answerCounts[answerNumber] = (answerCounts[answerNumber] || 0) + 1;
    }

    let mostFrequentAnswer = null;
    let maxCount = 0;
    for (const answer in answerCounts) {
      if (answerCounts[answer] > maxCount) {
        maxCount = answerCounts[answer];
        mostFrequentAnswer = parseInt(answer);
      }
    }

    setCorrectAnswerValue(
      challengeList?.resultList?.find((item) => item?.id === mostFrequentAnswer)
    );
    setIsResultScreen(true);
  };

  return (
    <div
      className={styles.wrapper}
      style={{ backgroundImage: backgroundImage }}
    >
      <div style={{ padding: '20px 30px 0' }}>
        <HeadContainer setScreenNumber={setScreenNumber} />
      </div>
      {isWelcomeScreen && !isResultScreen && (
        <div className={styles.welcomeContainer}>
          <p className={styles.title}>Знайди свій коктейль</p>
          <p className={styles.description}>
            Теплі дні у розпалі, тож саме час знайти ідеальний коктейль.{' '}
            <br></br>
            <br></br>Обирай інгредієнти — і дізнайся, що найкраще тебе освіжить!
          </p>
          <button onClick={() => setIsWelcomeScreen(false)}>Далі</button>
        </div>
      )}
      {!isWelcomeScreen && !isResultScreen && !isAfterResultScreen && (
        <div className={styles.challengeContainer}>
          <div className={styles.stepToolbar}>
            {challengeList.questions.map((item, index) => (
              <div
                key={index}
                className={classNames(
                  styles.stepItem,
                  index === challengeStep && styles.activeStepItem
                )}
              />
            ))}
          </div>
          <div className={styles.questionContainer}>
            <p className={styles.title}>{selectQuestion?.title}</p>
            <div className={styles.answerList}>
              {selectQuestion?.image && (
                <img src={selectQuestion?.image} alt={selectQuestion?.image} />
              )}
              {selectQuestion &&
                selectQuestion?.answerList?.map((item, index) => (
                  <div
                    key={item?.id}
                    className={classNames(
                      styles.answerItem,
                      item?.id === answers[challengeStep]?.answerId &&
                        styles.selectedAnswerItem
                    )}
                    onClick={() =>
                      onAnswerClick({
                        answerId: item?.id,
                        answer: item?.title
                      })
                    }
                  >
                    <p>{item?.title}</p>
                  </div>
                ))}
            </div>
          </div>
          <div className={styles.buttonContainer}>
            <div
              className={styles.leftButton}
              onClick={() => {
                if (challengeStep > 0) {
                  setChallengeStep(challengeStep - 1);
                  setSelectQuestion(
                    challengeList?.questions[challengeStep - 1]
                  );
                } else {
                  setIsWelcomeScreen(true);
                  setSelectQuestion(challengeList?.questions[0]);
                  setChallengeStep(0);
                  setIsResultScreen(false);
                  setAnswers([]);
                }
              }}
            >
              <img
                src="/images/luxury-expert-challenge/arrow.svg"
                alt="arrow"
              />
              <span>Назад</span>
            </div>
            {answers[challengeStep]?.answerId && (
              <div
                className={styles.rightButton}
                onClick={() => {
                  if (challengeStep + 1 >= challengeList?.questions?.length) {
                    onFinishClick();
                    return;
                  }
                  setChallengeStep(challengeStep + 1);
                  setSelectQuestion(
                    challengeList?.questions[challengeStep + 1]
                  );
                }}
              >
                <span>Далі</span>
                <img
                  src="/images/luxury-expert-challenge/arrow.svg"
                  alt="arrow"
                />
              </div>
            )}
          </div>
        </div>
      )}
      {isResultScreen && !isWelcomeScreen && (
        <div className={styles.resultContainer}>
          <p className={styles.headTitle}>Результат</p>
          <img src={correctAnswerValue?.image} alt="result-image" />
          <p className={styles.title}>{correctAnswerValue.title}</p>
          <p className={styles.description}>{correctAnswerValue.description}</p>
          <div className={styles.buttonContainer}>
            <div className={styles.viewRecipeButton}>
              <span onClick={() => setIsOpenRecipeModal(true)}>
                Переглянути рецепт
              </span>
              {isOpenRecipeModal && (
                <div className={styles.recipeModal}>
                  <img
                    className={styles.closeIcon}
                    src={getImageFromS3('images/lm-special/close-dialog.png')}
                    alt="closeIcon"
                    onClick={(event) => setIsOpenRecipeModal(false)}
                  />
                  {correctAnswerValue?.recipeText}
                </div>
              )}
            </div>
            <div
              className={styles.nextButton}
              onClick={() => {
                setIsResultScreen(false);
                setIsAfterResultScreen(true);
              }}
            >
              <span>Далі</span>
            </div>
          </div>
        </div>
      )}
      {isAfterResultScreen && !isWelcomeScreen && !isResultScreen && (
        <div className={styles.afterResultContainer}>
          <p className={styles.title}>Ну як тобі?</p>
          <p className={styles.description}>
            Тепер ти точно знаєш, чим освіжитись і підняти собі настрій сьогодні
            ввечері!
          </p>
          <button
            onClick={() => {
              setChallengeStep(0);
              setSelectQuestion(challengeList[0]);
              setCorrectAnswerValue(0);
              setIsResultScreen(false);
              setIsAfterResultScreen(false);
              setIsWelcomeScreen(true);
              afterResultButtonScreen();
            }}
          >
            <span>Далі</span>
          </button>
        </div>
      )}
    </div>
  );
};

export default FindYourCocktailChallenge;
